import React, { use, useEffect, useState } from "react";
import {
    Box,
    Grid,
    Typography,
    Card,
    CardContent,
    Button,
    Divider,
    ToggleButton,
    ToggleButtonGroup,
    Dialog, DialogTitle, DialogContent, DialogActions,
    IconButton,
    TextField, FormControl,
    Alert
} from "@mui/material";
import { resolvePath, useNavigate } from "react-router-dom";
import axios from "axios";
import { IconAlertTriangle, IconCheck, IconTrash, IconX } from "@tabler/icons-react";
import { useForm } from "react-hook-form";
import { BeatLoader } from "react-spinners";
import NoData from '.././Images/nodta'
import PageContainer from "./Pagecontainer";
import { Stack } from "react-bootstrap";
import ScheduleDemo from "./demo";
import Cookies from 'js-cookie';
const PlansPage = () => {
    const [billingCycle, setBillingCycle] = useState("Monthly");
    const { register, handleSubmit, formState: { errors }, trigger, setValue } = useForm();
    const [plans, setPlans] = useState([])
    const navigate = useNavigate()
    const [openDialog, setOpenDialog] = useState(false);
    const [OpenMail, setOpenMail] = useState(false)
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [activePlan, setActivePlan] = useState(null);
    const [ActivePlanData, setActivePlanData] = useState(null);
    console.log(ActivePlanData);
    const userInfo = JSON.parse(Cookies.get("user-info"));

    const [error, seterror] = useState('')
    const [loader, setloader] = useState(false)
    const [openSuccess, setOpenSuccess] = useState(false);
    const [referenceId, setReferenceId] = useState(null);
    const [Deletepopup, setDeletepopup] = useState(false)
    const [successPopup, setSuccessPopup] = useState(false)
    const [Errorpopup, setErrorpopup] = useState(false)
    const [errorMessage, seterrorMessage] = useState('')
    const [planid, setplanid] = useState('')
    const [selectedplan, setselectedplan] = useState([]);
    const UserInfo = JSON.parse(Cookies.get("user-info"));

    const GetPlans = async (planType = billingCycle) => {
        try {
            setloader(true)
            setPlans([]); 
            const config2 = {
                headers: { Authorization: `gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ==`, 'content-type': 'multipart/form-data' }
            }
            const response = await axios.get(`${process.env.REACT_APP_API_URL2}/apiV1/get-user-subscription-list/?is_deleted=false&user_id=${UserInfo.id}`, config2);
            if (response.status === 200) {
                const fetchedPlans = response.data;
                const filteredPlans = fetchedPlans.filter(plan => plan.plan_type === planType);
                setPlans(filteredPlans);
                const currentPlan = fetchedPlans.find(plan => plan.is_current_plan === true);
                setActivePlan(currentPlan?.id);
                setloader(false)
            }
        } catch (err) {
            console.log("Error fetching plans:", err);
            setloader(false)
        }
    };
    const GetactivePlan = async () => {
        try {
            const config2 = {
                headers: { Authorization: `gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ==`, 'content-type': 'multipart/form-data' }
            }
            const response = await axios.get(`${process.env.REACT_APP_API_URL2}/apiV1/get-user-subscription-details/?user_id=${UserInfo.id}`, config2)
            if (response.status === 200) {
                setActivePlanData(response.data[0])
            }
        } catch (err) {
            console.log("Error fetching plans:", err);
        }
    };
    // const reorderPlans = (plans) => {
    //     const currentPlanIndex = plans.findIndex(plan => plan.current_plan === true);
    //     if (currentPlanIndex !== -1) {
    //         const currentPlan = plans.splice(currentPlanIndex, 1)[0];
    //         const middleIndex = Math.floor(plans.length / 2);
    //         plans.splice(middleIndex, 0, currentPlan);
    //     }
    //     return plans;
    // };
    const handleSendEmail = async (data) => {
        setloader(true)
        try {
            let req = {
                plan_id: data?.id,
            }
            const response = await axios.post('/apiV1/assign-subscription/', req)
            if (response.status == 200) {
                setOpenSuccess(true)
                setReferenceId(response.data.reference_id)
                setloader(false)
                setOpenMail(false)
            }
        } catch (err) {
            console.log(err);
            seterror(err.response.data.message)
            setloader(false)
        }

    }

    const handleBillingChange = (event, newBillingCycle) => {
        if (newBillingCycle) {
            setBillingCycle(newBillingCycle);
            // GetPlans()
        }
        setselectedCard(null);
        setselectedplan([])
    };
    useEffect(() => {
        GetPlans()
        GetactivePlan()
    }, [billingCycle])
    // useEffect(() => {
    //     if (plans.length > 0) {
    //         const currentPlan = plans.find(plan => plan.current_plan === true);
    //         if (currentPlan) setActivePlan(currentPlan.id);
    //     }
    // }, [plans]);
    useEffect(() => {
        setValue("email", "enquiry@pranathiss.com");
        setValue("planName", selectedPlan?.name || "");
    }, [setValue, selectedPlan]);


    const handleCancel = async () => {
        try {
            setloader(true)
            let req = {
                current_subscription_id: planid
            }
            const config2 = {
                headers: { Authorization: `gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ==`, 'content-type': 'multipart/form-data' }
            }
            const response = await axios.post(`${process.env.REACT_APP_API_URL2}/apiV1/cancel-subscription/`, req,config2)
            if (response.status === 200) {
                setSuccessPopup(true)
                setDeletepopup(false)
                GetPlans()
                GetactivePlan()
                setloader(false)
            }
        } catch (err) {
            console.log(err);
            setDeletepopup(false)
            setErrorpopup(true)
            setloader(false)
            seterrorMessage(err.response.data.message)

        }
    }
    const [planName, setPlanName] = useState(null)
    const GetsinglePlanData = async (data) => {
        try {
            const config2 = {
                headers: { Authorization: `gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ==`, 'content-type': 'multipart/form-data' }
            }
            const response = await axios.get(`${process.env.REACT_APP_API_URL2}/apiV1/get-plan-bill-details/?is_deleted=false&user_id=${userInfo.id}&plan_id=${data}`, config2)
            if (response.status === 200) {
                setselectedplan(response.data)
            }
        } catch (err) {
            console.log(err);
            setselectedplan('')

        }
    }
    const [selectedCard, setselectedCard] = useState(null)
    const [selectedCardtype, setselectedCardtype] = useState(null)
    const handleCardClick = (index) => {
        setselectedCard(index);
    };
    const CreateNewBillingDetails = async () => {
        // let amount = 0
        //     Object.values(selectedplan).forEach((planamount) => {
        //         amount += planamount.amount;
        //     });
        // let bill_info = {
        //     pro_rata_details: selectedplan.pro_rata_details || {},
        //     regular_plan_details: selectedplan.regular_plan_details || {}
        // };
        let bill_info = {};
        if (selectedCardtype === "regular_plan_details") {
            bill_info = {
                pro_rata_details: selectedplan.regular_plan_details || {},
                regular_plan_details: selectedplan.regular_plan_details || {}
            };
        } else {
            bill_info = {
                pro_rata_details: selectedplan.pro_rata_details || {},
                regular_plan_details: selectedplan.regular_plan_details || {}
            };
        }
        let req = {
            customer_id: UserInfo.id,
            order_meta: {
                bill_info: bill_info
            }
        };
        try {
            const config2 = {
                headers: {
                    Authorization: `gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ==`,
                },
            };

            // Assuming `req` is your FormData or JSON payload
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL2}/apiV1/create-subscription-order/`,
                req,        // data goes here
                config2     // config goes here
            );

            if (response.status === 200) {
                navigate(`/plans/billing?id=${response.data.data.order_id}&selectedplanid=${activePlan}&planName=${planName}&currentplanid=${ActivePlanData?.id}&type=${ActivePlanData?.is_renewal === false ? "NEW" : "RENEWAL"}`);
            }
        } catch (err) {
            console.log(err);

        }

    }
    return (
        <>
            <PageContainer title="SmartInvestorDeck | Plans">
             <ScheduleDemo showBanner={true} />
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Box>
                        <ToggleButtonGroup
                            value={billingCycle}
                            exclusive
                            onChange={handleBillingChange}
                            sx={{
                                // margin: "auto",
                                mx: 1,
                                marginBottom: 4,
                                display: "flex",
                                justifyContent: "center",
                                borderRadius: "8px",
                                width: "fit-content",
                                border: "1px solid #ddd",
                            }}
                        >
                            <ToggleButton
                                value="Monthly"
                                sx={{
                                    textTransform: "none",
                                    fontWeight: "bold",
                                    padding: "10px 20px",
                                    borderRadius: "8px",
                                    "&.Mui-selected": {
                                        backgroundColor: "#07659b",
                                        color: "#fff",
                                        "&:hover": {
                                            backgroundColor: "#66a321",
                                        },
                                    },
                                    minWidth: "120px",
                                }}
                            >
                                Monthly
                            </ToggleButton>
                            <ToggleButton
                                value="Annually"
                                sx={{
                                    textTransform: "none",
                                    fontWeight: "bold",
                                    padding: "10px 20px",
                                    borderRadius: "8px",
                                    "&.Mui-selected": {
                                        backgroundColor: "#07659b",
                                        color: "#fff",
                                        "&:hover": {
                                            backgroundColor: "#66a321",
                                        },
                                    },
                                    minWidth: "120px",
                                }}
                            >
                                Annually
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Box>
                   {ActivePlanData?.is_in_trail === false ?
                    <Box >
                        <Button variant="contained"className="button2" sx={{ mr: 2 }} onClick={() => navigate('/plans/cardDetails')}>Card Details</Button>
                        <Button variant="contained"className="button2" onClick={() => navigate('/plans/transactionhistory')}>Transaction History</Button>
                    </Box>
                     :""} 
                </Box>
                {loader ? (
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "76vh" }}>
                        <BeatLoader color="#07659c" size={24} />
                    </Box>
                ):(
                    <Card
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            p: 3,
                            m: 2,
                            boxShadow:
                                "rgba(0, 0, 0, 0.05) 0px 6px 24px, rgba(0, 0, 0, 0.08) 0px 0px 1px",
                        }}
                    >
                        <Grid container spacing={3}>
                            {/* Left section: Plan Cards */}
                            <Grid item xs={12} md={8} lg={9}>
                                <Grid container spacing={3}>
                                    {plans.map((plan) => (
                                        <Grid item xs={12} sm={6} md={4} key={plan.id}>
                                            <Card
                                                onClick={() => {
                                                    setActivePlan(plan.id);
                                                    GetsinglePlanData(plan.id);
                                                    setPlanName(plan.name);
                                                }}
                                                sx={{
                                                    backgroundColor: "#ffffff",
                                                    borderRadius: "10px",
                                                    width: "100%",
                                                    boxShadow:
                                                        activePlan === plan.id
                                                            ? "0px 8px 20px rgba(74, 58, 255, 0.2)"
                                                            : "none",
                                                    border:
                                                        activePlan === plan.id
                                                            ? "2px solid #66a321"
                                                            : "1px solid #e0e0e0",
                                                    padding: "15px",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                <CardContent>
                                                    {plan.is_current_plan && (
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                justifyContent: "flex-end",
                                                                position: "relative",
                                                                bottom: "31px",
                                                                left: "33px",
                                                            }}
                                                        >
                                                            <Box
                                                                sx={{
                                                                    backgroundColor: "#66a321",
                                                                    color: "#fff",
                                                                    fontSize: "12px",
                                                                    fontWeight: "bold",
                                                                    padding: "6px 8px",
                                                                }}
                                                            >
                                                                Current Plan
                                                            </Box>
                                                        </Box>
                                                    )}

                                                    <Typography variant="h5" fontWeight="bold" mb={1}>
                                                        {plan.name}
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary">
                                                        {plan.description}
                                                    </Typography>
                                                    <Typography variant="h4" fontWeight="bold" mt={2} mb={2}>
                                                        ${plan.price}
                                                    </Typography>

                                                    {plan.trial && (
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            mb={2}
                                                        >
                                                            {plan.trial}
                                                        </Typography>
                                                    )}
                                                    <Divider sx={{ mb: 2 }} />
                                                    <Box>
                                                        {plan.perks?.length > 0 ? (
                                                            plan.perks.map((feature, i) => (
                                                                <Typography key={i} variant="body1" mb={1} textAlign="left">
                                                                    <span style={{ color: "green",fontSize: "15px",fontWeight: 600}}>✓</span> {typeof feature === "string" ? feature : feature.name || "Feature"}
                                                                </Typography>
                                                            ))
                                                        ) : (
                                                            <Typography variant="body2" color="text.secondary">
                                                                No features available
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                    <Divider sx={{ mt: 2, mb: 2 }} />

                                                    {plan.is_current_plan && (
                                                        <>
                                                            <Button
                                                                fullWidth
                                                                variant="contained"
                                                                className="button2"
                                                                disabled={plan.id !== activePlan}
                                                                sx={{
                                                                    mt: 2,
                                                                    fontWeight: "bold",
                                                                    color: "#fff",
                                                                }}
                                                                onClick={() => setOpenDialog(true)}
                                                            >
                                                                View Details
                                                            </Button>
                                                            {ActivePlanData?.is_cancelled === false && (
                                                                <Button
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    disabled={plan.id !== activePlan}
                                                                    sx={{
                                                                        mt: 2,
                                                                        fontWeight: "bold",
                                                                        color: "#fff",
                                                                        backgroundColor:
                                                                            plan.id === activePlan ? "#c63137" : "#e0e0e0",
                                                                    }}
                                                                    onClick={() => {
                                                                        setDeletepopup(true);
                                                                        setplanid(ActivePlanData.id);
                                                                    }}
                                                                >
                                                                   {loader ? <BeatLoader/>:"Cancel Plan"} 
                                                                </Button>
                                                            )}
                                                            {ActivePlanData?.is_cancelled === true && (
                                                                <Typography sx={{ mt: 2, textAlign: "center", color: "red" }}>
                                                                    Your plan has been canceled
                                                                </Typography>
                                                            )}
                                                        </>
                                                    )}
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    ))}
                                </Grid>
                                    {plans.length === 0 && (
                                        <Grid item xs={12}>
                                            <Typography variant="h6" align="center" sx={{ mt: 2 }}>
                                                No Plans Available
                                            </Typography>
                                        </Grid>
                                    )}
                            </Grid>

                            {/* Right section: Selected Plan Summary */}
                            <Grid item xs={12} md={4} lg={3}>
                                {Object.entries(selectedplan).map(([key, pland], i) => (
                                    <Card
                                        key={i}
                                        sx={{
                                            mb: 2,
                                            p: 2,
                                            borderRadius: "10px",
                                            border: selectedCard === i ? "1px solid #104672" : "",
                                            backgroundColor: selectedCard === i ? "#c9e3f1" : "",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => {
                                            handleCardClick(i);
                                            setselectedCardtype(key);
                                        }}
                                    >
                                        <Typography
                                            variant="h6"
                                            sx={{
                                                color: "#182286",
                                                fontSize: "17px",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                                fontWeight: 800,
                                            }}
                                        >
                                            <input type="radio" checked={selectedCard === i} readOnly />
                                            {key === "pro_rata_details" ? "Prorated Amount" : "Full Amount"}
                                        </Typography>

                                        <Typography sx={{ pt: 2, pb: 2, fontSize: "14px" }}>
                                            {key === "pro_rata_details"
                                                ? "Amount & services are calculated for the remaining days left in the current month."
                                                : "Full amount will be debited as per the current plan."}
                                        </Typography>

                                        <Box sx={{ mb: 1, display: "flex" }}>
                                            <Box mr="auto">
                                                <Typography fontSize="14px">Current Plan</Typography>
                                            </Box>
                                            <Box sx={{ fontWeight: "bold", color: "#182286", fontSize: "14px" }}>
                                                {pland.plan_name}
                                            </Box>
                                        </Box>

                                        <Box sx={{ mb: 1, display: "flex" }}>
                                            <Box mr="auto">
                                                <Typography fontSize="14px">No of Projects</Typography>
                                            </Box>
                                            <Box sx={{ fontWeight: "bold", color: "#182286", fontSize: "14px" }}>
                                                {pland.no_of_projects_allowed}
                                            </Box>
                                        </Box>

                                        <Box sx={{ mb: 1, display: "flex" }}>
                                            <Box mr="auto">
                                                <Typography fontSize="14px">No of Document Generation</Typography>
                                            </Box>
                                            <Box sx={{ fontWeight: "bold", color: "#182286", fontSize: "14px" }}>
                                                {pland.no_document_generation}
                                            </Box>
                                        </Box>

                                        <Box sx={{ mb: 1, display: "flex" }}>
                                            <Box mr="auto">
                                                <Typography fontSize="14px">No of AI Suggestions</Typography>
                                            </Box>
                                            <Box sx={{ fontWeight: "bold", color: "#182286", fontSize: "14px" }}>
                                                {pland.ai_suggestions_allowed}
                                            </Box>
                                        </Box>

                                        <Divider />
                                        <Box sx={{ mt: 2, display: "flex" }}>
                                            <Box mr="auto">
                                                <Typography fontSize="14px">Total Amount</Typography>
                                            </Box>
                                            <Box sx={{ fontWeight: "bold", color: "#182286", fontSize: "14px" }}>
                                                ${pland.amount}
                                            </Box>
                                        </Box>
                                    </Card>
                                ))}

                                {selectedCard !== null && (
                                    <Box sx={{ display: "flex", gap: 2 }}>
                                        <Button
                                            variant="outlined"
                                            onClick={() => {
                                                setselectedCard(null);
                                                setselectedplan([]);
                                                setActivePlan(null);
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                        <Button variant="contained" className="button2" onClick={CreateNewBillingDetails}>
                                            Buy
                                        </Button>
                                    </Box>
                                )}
                            </Grid>
                        </Grid>
                    </Card>

                )}
                {error && <Alert severity="error">{error}</Alert>}

                <Dialog open={openSuccess} onClose={() => setOpenSuccess(false)} fullWidth maxWidth="sm">
                    <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        Success
                        <IconButton onClick={() => setOpenSuccess(false)}>
                            <IconX size={24} />
                        </IconButton>
                    </DialogTitle>
                    <Divider />
                    <DialogContent sx={{ textAlign: "center" }}>
                        <Typography variant="body1" gutterBottom>
                            Subscription email sent successfully.
                        </Typography>
                        <Typography variant="body2">
                            <strong>Reference ID:</strong> {referenceId}
                        </Typography>
                        <Button
                            variant="outlined"
                            size="small"
                            sx={{ marginTop: 1, fontSize: "small" }}
                            onClick={() => {
                                navigator.clipboard.writeText(referenceId);
                            }}
                        >
                            Copy
                        </Button>
                    </DialogContent>
                    <Divider />
                    <DialogActions>
                        <Button onClick={() => setOpenSuccess(false)} variant="contained" color="primary">
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* <Dialog open={OpenMail} onClose={() => setOpenMail(false)}>
                <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    Contact Sales
                    <IconButton onClick={() => setOpenMail(false)}>
                        <IconX size={24} />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Box>
                        <form onSubmit={handleSubmit(handleSendEmail)}>
                            <FormControl variant="standard" fullWidth margin="dense">
                                <Typography variant="body2" gutterBottom>Email</Typography>
                                <TextField
                                    fullWidth
                                    id="email-input"
                                    type="email"
                                    disabled
                                    {...register("email")}
                                />
                            </FormControl>
                            <FormControl variant="standard" fullWidth margin="dense">
                                <Typography variant="body2" gutterBottom>Plan Name</Typography>
                                <TextField
                                    fullWidth
                                    id="plan-name-input"
                                    disabled
                                    {...register("planName")}
                                />
                            </FormControl>
                            <FormControl variant="standard" fullWidth margin="dense">
                                <Typography variant="body2" gutterBottom>Message</Typography>
                                <textarea
                                    id="message-input"
                                    rows={4}
                                    style={{
                                        width: "100%",
                                        padding: "8px",
                                        fontSize: "16px",
                                        borderRadius: "4px",
                                        border: "1px solid #ccc",
                                        outline: "none",
                                        resize: "vertical"
                                    }}
                                    {...register("message", { required: "Message is required" })}
                                    onKeyUp={() => trigger("message")}
                                    error={!!errors.message}
                                    helperText={errors.message?.message}
                                />
                            </FormControl>
                            {error && <Alert>{error}</Alert>}
                            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3, gap: 2 }}>
                                <Button
                                    variant="outlined"
                                    onClick={() => setOpenMail(false)}
                                    sx={{ textTransform: "none" }}
                                    disabled={loader}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    className="button2"
                                    disabled={loader}
                                >
                                    {loader ? <BeatLoader size={20} color="#4a77f8" /> : <Typography>Send Mail</Typography>}
                                </Button>
                            </Box>
                        </form>
                    </Box>
                </DialogContent>
            </Dialog> */}

                <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth maxWidth="sm">
                    <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        Current Plan Details
                        <IconButton onClick={() => setOpenDialog(false)}>
                            <IconX size={24} />
                        </IconButton>
                    </DialogTitle>
                    <Divider />
                    <DialogContent>
                        {ActivePlanData && <>
                            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
                                Plan Name: {ActivePlanData.plan__name}
                            </Typography>
                            {/* <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                            {ActivePlanData.currency}
                        </Typography> */}
                            <Typography variant="h5" sx={{ mb: 1 }}>
                                Price : {ActivePlanData.currency}  {ActivePlanData.total_amount}
                            </Typography>
                            <Typography sx={{ mb: 1 }}>
                                Start Date : {new Date(ActivePlanData.start_date).toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                }).replace(/\//g, "-")}
                            </Typography>
                            <Typography sx={{ mb: 1 }}>
                                End Date : {new Date(ActivePlanData.sub_expiry_date_).toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                }).replace(/\//g, "-")}

                            </Typography>
                            {/* {ActivePlanData?.is_subscribed ?
                                <>
                                    <Divider /><Typography sx={{ fontWeight: 600 }}>Trail Period</Typography>
                                    <Typography sx={{ mb: 1 }}>
                                        Remaining Projects: {ActivePlanData.remaining_trail_projects}/{ActivePlanData.trail_record__total_projects}
                                    </Typography>
                                    <Typography sx={{ mb: 1 }}>
                                        Remaining Ai Suggestions: {ActivePlanData.remaining_trail_ai_suggestions}/{ActivePlanData.trail_record__total_ai_suggestions}
                                    </Typography>
                                    <Typography sx={{ mb: 1 }}>
                                        Remaining Document Generation: {ActivePlanData.remaining_trail_document_gen}/{ActivePlanData.trail_record__total_document_generation}
                                    </Typography></> : ""} */}
                            <Divider />
                            <Typography sx={{ fontWeight: 600 }}> Subscription Details:</Typography>
                            <Typography sx={{ mb: 1 }}>
                                Remaining Projects: {ActivePlanData.remaining_subscription_projects}/{ActivePlanData.total_no_of_projects}
                            </Typography>
                            <Typography sx={{ mb: 1 }}>
                                Remaining Ai Suggestions: {ActivePlanData.remaining_ai_suggestions}/{ActivePlanData.total_no_of_ai_suggestions}
                            </Typography>
                            <Typography sx={{ mb: 1 }}>
                                Remaining Document Generation: {ActivePlanData.remaining_subscription_document}/{ActivePlanData.total_no_of_document_gen}
                            </Typography>
                        </>}
                        <Divider />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpenDialog(false)} color="primary" variant="contained">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={Deletepopup}
                    onClose={() => setDeletepopup(false)}
                    aria-labelledby="confirm-cancel-dialog-title"
                    aria-describedby="confirm-cancel-dialog-description"
                    PaperProps={{
                        sx: { borderRadius: '16px', padding: '16px' },
                    }}
                >
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Box />
                        <IconButton size="small" onClick={() => setDeletepopup(false)}>
                            <IconX />
                        </IconButton>
                    </Box>
                    <DialogTitle id="confirm-cancel-dialog-title" align="center" sx={{ marginTop: -3 }}>
                        <Box display="flex" justifyContent="center" alignItems="center">
                            <Box
                                sx={{
                                    width: 60,
                                    height: 60,
                                    backgroundColor: '#fff3cd',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    borderRadius: '50%',
                                    marginBottom: 2,
                                }}
                            >
                                <IconAlertTriangle size={32} color="#ff9800" />
                            </Box>
                        </Box>
                        <Typography variant="h6" fontWeight="bold">
                            Confirm Cancellation
                        </Typography>
                    </DialogTitle>
                    <DialogContent>
                        <Typography id="confirm-cancel-dialog-description" align="center">
                            Are you sure you want to cancel your plan? You will lose access to premium features.
                        </Typography>
                    </DialogContent>
                    <DialogActions
                        sx={{ display: 'flex', justifyContent: 'center', gap: 2, marginBottom: 1 }}
                    >
                        <Button
                            variant="outlined"
                            color="inherit"
                            sx={{
                                width: 120,
                                borderColor: '#e0e0e0',
                            }}
                            onClick={() => setDeletepopup(false)}
                        >
                            Keep Plan
                        </Button>
                        <Button
                            variant="contained"
                            color="error"
                            sx={{ backgroundColor: "#c63037", border: "none" }}
                            onClick={handleCancel}
                        >
                            Cancel Plan
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* successPopup Dialog  */}
                <Dialog
                    open={successPopup}
                    onClose={() => setSuccessPopup(false)}
                    aria-labelledby="success-dialog-title"
                    aria-describedby="success-dialog-description"
                    PaperProps={{
                        sx: { borderRadius: '16px', padding: '16px' },
                    }}
                // fullWidth
                // sx={{maxWidth:"lg"}}
                >
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Box />
                        <IconButton size="small" onClick={() => setSuccessPopup(false)}>
                            <IconX />
                        </IconButton>
                    </Box>
                    <DialogTitle id="success-dialog-title" align="center" sx={{ marginTop: -3 }}>
                        <Box display="flex" justifyContent="center" alignItems="center">
                            <Box
                                sx={{
                                    width: 60,
                                    height: 60,
                                    backgroundColor: '#e8f5e9',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    borderRadius: '50%',
                                    marginBottom: 2,
                                }}
                            >
                                <IconCheck size={40} color="#4caf50" />
                            </Box>
                        </Box>
                    </DialogTitle>
                    <DialogContent>
                        <Typography id="success-dialog-description" align="center">
                            Your plan has been successfully canceled. You will no longer be charged for the next billing cycle.
                        </Typography>
                    </DialogContent>
                    <DialogActions
                        sx={{ display: 'flex', justifyContent: 'center', gap: 2, marginBottom: 1 }}
                    >
                        <Button
                            variant="contained"
                            color="primary"
                            sx={{ width: 120 }}
                            onClick={() => setSuccessPopup(false)}
                        >
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={Errorpopup}
                    onClose={() => setErrorpopup(false)}
                    aria-labelledby="error-dialog-title"
                    aria-describedby="error-dialog-description"
                    PaperProps={{
                        sx: { borderRadius: "16px", padding: "16px" },
                    }}
                    fullWidth
                    maxWidth="sm"
                >
                    {/* Close Button */}
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Box />
                        <IconButton size="small" onClick={() => setErrorpopup(false)}>
                            <IconX />
                        </IconButton>
                    </Box>

                    {/* Error Icon & Title */}
                    <DialogTitle id="error-dialog-title" align="center" sx={{ marginTop: -3 }}>
                        <Box display="flex" justifyContent="center" alignItems="center">
                            <Box
                                sx={{
                                    width: 60,
                                    height: 60,
                                    backgroundColor: "#fff3cd",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    borderRadius: "50%",
                                    marginBottom: 2,
                                }}
                            >
                                <IconAlertTriangle size={32} color="#ff9800" />
                            </Box>
                        </Box>
                        <Typography variant="h6" fontWeight="bold">
                            Error
                        </Typography>
                    </DialogTitle>

                    {/* Error Message */}
                    <DialogContent>
                        <Typography id="error-dialog-description" align="center">
                            {errorMessage || "An unexpected error has occurred. Please try again."}
                        </Typography>
                    </DialogContent>

                    {/* Close Button */}
                    <DialogActions sx={{ display: "flex", justifyContent: "center", gap: 2, marginBottom: 1 }}>
                        <Button
                            variant="contained"
                            color="error"
                            sx={{ backgroundColor: "#c63037", border: "none" }}
                            onClick={() => setErrorpopup(false)}
                        >
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </PageContainer>
        </>
    );
};

export default PlansPage;
